import { makeStyles, Theme } from '@material-ui/core';
import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import DGManagementGrid from './DGManagementGrid';

const useStyles = makeStyles((theme: Theme) => ({
    dialogHeader: {
        '& .k-window-titlebar.k-header': {
            padding: theme.spacing(1, 2),
            backgroundColor: theme.palette.info.main,
            fontWeight: 'normal',
        },
        '& .k-content': {
            boxSizing: 'border-box',
            padding: theme.spacing(0, 2),
            paddingTop: theme.spacing(1),
        },
    },
}));

const DGManagement = ({ openedDGManagement, setOpenedDGManagement }: any) => {
    const classes = useStyles();

    return (
        <div>
            {openedDGManagement && (
                <Dialog
                    title={' '}
                    onClose={() => setOpenedDGManagement(!openedDGManagement)}
                    width="50vw"
                    height="auto"
                    className={classes.dialogHeader}
                >
                    <DGManagementGrid />
                </Dialog>
            )}
        </div>
    );
};

export default DGManagement;
